/**
 * Zonas activas de localstorage
 */
import { ebook, config } from "@/config/Ebook.json";//Configuraciones del Ebook
import zonasActivas from "@/config/ZonasActivas.json";//Zonas activas que tendra el Ebook

class LocalService {
    miStorage
    localZone
    idZone      //Cantidad de zonas activas que hay
    indexEbook  //Ubicacion de la pagina del ebook
    idEbook     //ID del ebook, con este id se localiza los datos en el localstorage

    constructor() {
        this.miStorage = window.localStorage;
        this.idEbook = config.id;
        this.localZone = JSON.parse(this.miStorage.getItem(this.idEbook + "_ZoneActive"));
        this.idZone = this.miStorage.getItem(this.idEbook + "_ID");
        this.indexEbook = JSON.parse(this.miStorage.getItem(this.idEbook + "_index"));

        if (!this.localZone) {
            if (Object.entries(zonasActivas).length === 0) {
                this.localZone = {}
                for (var i = 0; i < ebook.length; i++) {
                    this.localZone[i] = {}
                }
            } else {
                this.localZone = zonasActivas;
            }
        }

        if (!this.indexEbook) {
            this.indexEbook = null
        }

        if (!this.idZone) {
            this.idZone = 1;
            for (let i = 0; i < ebook.length; i++) {
                if (zonasActivas[i] != null) {

                    for (let key in zonasActivas[i]) {
                        let value = zonasActivas[i][key];

                        for (let j = 0; j < value.length; j++) {
                            console.log(value[j]["id"])
                            if (this.idZone < value[j]["id"]) {
                                this.idZone = value[j]["id"];
                            }
                        }
                    }
                }
            }
            this.idZone ++;
        }
    }

    setZoneActive(zone) {
        this.localZone = zone;
        this.miStorage.setItem(this.idEbook + "_ZoneActive", JSON.stringify(zone));
    }

    getZoneActive(zone) {
        return this.localZone;
    }

    setIndexEbook(index) {
        this.indexEbook = index;
        this.miStorage.setItem(this.idEbook + "_index", JSON.stringify(index));
    }

    getIndexEbook(zone) {
        return this.indexEbook;
    }

    setIDZone(id) {
        this.idZone = id;
        this.miStorage.setItem(this.idEbook + "_ID", id);
    }

    getIDZone() {
        return this.idZone
    }
}

let service = new LocalService()

export default service